/**
 * Created by fers on 23.05.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import EventTracker from '../app/EventTracker';

import {MiniPanel} from './EmbededPanel.react';
import * as BrowserPermission from "../BrowserPermission";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import { User } from '../../common/types/types';

interface EmptyPanelProps {
    user: User;
}

class EmptyPanel extends React.Component<EmptyPanelProps> {

    static contextTypes = {
        router: PropTypes.object,
    };

    static propTypes = {
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);

        BrowserPermission.setPermissionObject({
            id: props.user.realId,
            globalPermissions: props.user.globalPermissions ? safeJSONparse(props.user.globalPermissions) : [],
            organisationPermissions: props.user.organisations2user.edges.map(({node}) => ({id: node.id, organisation_id: node.organisation_id, role: node.role, permissions: safeJSONparse(node.permissions)})),
            featureFlags: props.user.featureFlags ? safeJSONparse(props.user.featureFlags) : {}
        });
    }

    render() {
        return (
            <MiniPanel typeForTest="empty">
                <div className="bordered-content">
                    <div className="embedLoading"><i className="fa fa-refresh fa-spin fa-3x fa-fw margin-bottom" style={{color: '#aaaaf0'}}></i></div>
                </div>
            </MiniPanel>
        );
    }
}

export default Relay.createContainer(EmptyPanel, {
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()}
                }
            `;
        }
    }
});
